import { SCI_PALETTE } from "@/lib/science/sci-chart";
import { cartesianAxis, PlotShell } from "@/lib/science/sci-plot";
import { m } from "@/paraglide/messages";

const SCATTER_EXAMPLE = "x,y\n1,2.1\n2,3.9\n3,3.2\n4,6.1\n5,5.4\n6,7.8\n7,7.1";
const BUBBLE_EXAMPLE =
  "x,y,size\n10,20,30\n25,35,90\n40,15,50\n55,50,120\n70,30,70";

export function ScatterPlot({ bubble = false }: { bubble?: boolean }) {
  return (
    <PlotShell
      toolId={bubble ? "bubble-chart" : "scatter-plot"}
      inputLabel={m.plot_input_label()}
      placeholder={bubble ? m.bubble_placeholder() : m.scatter_placeholder()}
      example={bubble ? BUBBLE_EXAMPLE : SCATTER_EXAMPLE}
      exampleLabel={m.plot_load_example()}
      hint={m.plot_hint_empty()}
      buildOption={(data, theme) => ({
        tooltip: { trigger: "item" },
        grid: { left: 48, right: 24, top: 24, bottom: 36 },
        xAxis: {
          type: "value",
          name: data.colHeaders[0] ?? "x",
          nameTextStyle: { color: theme.muted },
          ...cartesianAxis(theme),
        },
        yAxis: {
          type: "value",
          name: data.colHeaders[1] ?? "y",
          nameTextStyle: { color: theme.muted },
          ...cartesianAxis(theme),
        },
        series: [
          {
            type: "scatter",
            data: data.matrix.filter(
              (r) => Number.isFinite(r[0]) && Number.isFinite(r[1]),
            ),
            symbolSize: bubble
              ? (d: number[]) => 6 + Math.sqrt(Math.abs(d[2] ?? 0))
              : 12,
            itemStyle: { color: SCI_PALETTE[bubble ? 1 : 0], opacity: 0.8 },
          },
        ],
      })}
    />
  );
}
